const SvgRegisterExpense = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 200 200" {...props}>
        <path d="M140 100h25" />
        <path
            fill="none"
            fill-rule="evenodd"
            stroke="#B3DFD8"
            stroke-miterlimit="10"
            stroke-width="10"
            d="M30 40h25v90h90l20-20V70H80"
        />
        <circle fill="#B3DFD8" cx="70" cy="155" r="5" />
        <circle fill="#B3DFD8" cx="130" cy="155" r="5" />
        <circle
            cx="100.5"
            cy="100.5"
            r="100"
            fill="none"
            stroke="#b5e3d8"
            strokeMiterlimit="10"
        />
    </svg>
);

export default SvgRegisterExpense;
